import { render, staticRenderFns } from "./transaction-detail.vue?vue&type=template&id=36e001a0&"
import script from "./transaction-detail.vue?vue&type=script&lang=js&"
export * from "./transaction-detail.vue?vue&type=script&lang=js&"
import style0 from "./transaction-detail.vue?vue&type=style&index=0&id=36e001a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports